import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from 'recoil';
import {
    Button, Dialog, DialogTitle, ButtonGroup, DialogContentText, DialogContent,
    FormControl, InputBase, InputLabel, MenuItem, FormControlLabel, Checkbox, Select
} from "@material-ui/core/";
import { makeStyles, withStyles, fade } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
import CredentialService from "../../../services/CredentialService/CredentialService";
import { alertState } from "../../../recoil-store/recoil-state";
import { TextInput } from "../TextInput/NewTextInput";
import "./ParamsModal.css";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "75%"
    },
    bottomSection: {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        float: "right",
        "&:focus": {
            outline: "none"
        }
    },
    submit: {
        color: "white",
        marginLeft: 15,
        backgroundColor: "#079063",
        cursor: "pointer"
    }
}));
const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(3)
        }
    },
    input: {
        borderRadius: 2,
        border: '0.5px solid #D5D5D5',
        fontSize: 16,
        width: "315px",
        padding: "10px 12px",
        height: "9.2px !important",
        maxHeight: "9.2px!important",
        // Use the system font instead of the default Roboto font.
        "&:focus": {
            boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main
        }
    }
}))(InputBase);

const ParamsModal = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [btnChangeColor, setBtnChangeColor] = useState(1);
    const [credentials, setCredentials] = useState([]);
    const [credentialsAttr, setCredentialsAttr] = useState([]);
    const [paramsName, setParamsName] = useState("");
    // if  action is service desk plus , isActive : true
    const [active, setActive] = useState(true);//props.action?.libraryName==="SERVICE-DESK-PLUS");
    const [credentialsId, setCredentialsId] = useState("");
    const [attr, setAttr] = useState("");
    const [isSave, setIsSave] = useState(false);
    const [value, setValue] = useState(props.action?.libraryName === "SERVICE-DESK-PLUS" ? 3 : 1);
    const [credentialsName, setCredentialsName] = useState([]);
    const [valueType, setValueType] = useState('text');
    const [subType, setSubType] = useState('filePath');
    const setAlert = useSetRecoilState(alertState);

    const handleClick = (val) => {
        setValue(val);
        setBtnChangeColor(val);
    };

    const handleClose = () => {
        //If we don't press save, we delete it because the fields is created during the first loading.
        if (!isSave) {
            props.action.fields[props.inputName].value.pop();
        }
        props.setOpen(false);
    };

    useEffect(() => {
        if (!props.isActiveDirectory) {
            CredentialService.getCredentials("1")
                .then((response) => {
                    setCredentials(response.data);
                    props.setRefresh(true);
                })
                .catch((error) => {
                    //err
                });
        } else {
            props.setRefresh(true);
        }
    }, []);

    useEffect(() => {
        if (credentialsId !== null) {
            CredentialService.getCredentialByFilter(credentialsId)
                .then((response) => {
                    setCredentialsAttr(response.data);
                })
                .catch((error) => {
                    //err
                });
        }
    }, [credentialsId]);

    //set credentials name
    function handleCredentials(e) {
        setCredentialsId(e.target.value);
        let credName = credentials.filter(item => item.connection_id === e.target.value)
        setCredentialsName(credName)
    }


    const childCredential = () => {
        return (
            <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                    {t("PARAMSMODAL.ATTIRBUTE")}
                </InputLabel>
                <Select
                    style={{ height: "35px!important", minWidth: "200px" }}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={attr}
                    onChange={(e) => setAttr(e.target.value)}
                    label={t("PARAMSMODAL.ATTIRBUTE")}
                >
                    {credentialsAttr.connection_attributes &&
                        credentialsAttr?.connection_attributes?.map(
                            (item, index) =>
                                item !== undefined && (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                )
                        )}
                </Select>
            </FormControl>
        );
    };
    const credentialsPicker = () => {
        return (
            <div className="button-select">
                <div className="button-align">
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="demo-simple-select-outlined-label">
                            {t("PARAMSMODAL.CREDENTIALS")} {t("PARAMSMODAL.NAME")}
                        </InputLabel>
                        <Select
                            style={{ height: "35px!important", minWidth: "200px" }}
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={credentialsId}
                            onChange={(e) => handleCredentials(e)}
                            label={`${t("PARAMSMODAL.CREDENTIALS")} ${t("PARAMSMODAL.NAME")}`}
                        >
                            {credentials?.length > 0 &&
                                credentials.map(
                                    (item, index) =>
                                        item !== undefined && (
                                            <MenuItem key={item.connection_id} value={item.connection_id}>
                                                {item.connection_name}
                                            </MenuItem>
                                        )
                                )}
                        </Select>
                    </FormControl>
                    {childCredential()}
                </div>
            </div>
        );
    }

    useEffect(() => {
        if (!props.isActiveDirectory) {
            props.action.fields[props.inputName].value.push({
                isActive: "",
                name: "",
                value: "",
            });
        } else {
            props.action.fields[props.inputName].value.push({
                value: ""
            });
        }
    }, [props.action]);

    const customString = () => {

        return (
            <TextInput
                action={
                    props.action.fields[props.inputName].value[
                    props.action.fields[props.inputName].value.length - 1
                    ]
                }
                variables={props.variable}
                setOpenVariable={props.setOpenVariable}
            />
        );
    };

    const updateValueType = (type) => {
        setValueType(type);
    }

    const updateSubType = (type) => {
        setSubType(type);
    }

    const handleAdd = () => {

        setIsSave(true);
        if (props.isActiveDirectory) {
            if (props.action.fields[props.inputName].value[
                props.action.fields[props.inputName].value.length - 1
            ].value.length > 0) {
                props.setOpen(false);
            } else {
                setAlert(alert => ({ ...alert, show: true, message: t("ACTIVE-DIRECTORY.NOT-NULL"), severity: 'error' }))
            }
        } else {
            if (paramsName.length > 0) {
                props.action.fields[props.inputName].value[
                    props.action.fields[props.inputName].value.length - 1
                ].isActive = active;
                props.action.fields[props.inputName].value[
                    props.action.fields[props.inputName].value.length - 1
                ].name = paramsName;
                if (props.formData) {
                    props.action.fields[props.inputName].value[
                        props.action.fields[props.inputName].value.length - 1
                    ].type = valueType;
                    if (valueType === 'file') {
                        props.action.fields[props.inputName].value[
                            props.action.fields[props.inputName].value.length - 1
                        ].subType = subType;
                    }
                }

                //selected  connection pool fields then added                
                if (!(props.formData && valueType === 'file') && value === 1) {
                    props.action.fields[props.inputName].value[
                        props.action.fields[props.inputName].value.length - 1
                    ].value = credentialsName[0].connection_name;
                    props.action.fields[props.inputName].value[
                        props.action.fields[props.inputName].value.length - 1
                    ].attributeId = attr;
                    props.action.fields[props.inputName].value[
                        props.action.fields[props.inputName].value.length - 1
                    ].credentialsId = credentialsId;
                }

                props.setOpen(false);
            } else {
                setAlert(alert => ({ ...alert, show: true, message: t("ACTIVE-DIRECTORY.NOT-NULL"), severity: 'error' }))
            }
        }
    };

    const showValueDesign = () => {
        if (props.isActiveDirectory) {
            return <DialogContentText style={{ color: "black" }}>
                {customString()}
            </DialogContentText>
        } else if (props.formData && valueType === 'file') {
            return <DialogContentText style={{ color: "black" }}>
                <ButtonGroup size="medium" aria-label="small outlined button group">
                    <Button
                        className={subType === 'filePath' ? "btn-gray" : ""}
                        id="button-group"
                        onClick={(e) => updateSubType('filePath')}
                        variant="outlined"
                    >
                        {t("PARAMSMODAL.FILE-PATH")}
                    </Button>
                    <Button
                        className={subType === 'base64' ? "btn-gray" : ""}
                        id="button-group"
                        onClick={(e) => updateSubType('base64')}
                        variant="outlined"
                    >
                        {t("PARAMSMODAL.BASE64")}
                    </Button>
                </ButtonGroup>
                <div className="params-list">
                    {customString()}
                </div>
            </DialogContentText>
        } else {
            return <DialogContentText style={{ color: "black" }}>
                <ButtonGroup size="medium" aria-label="small outlined button group">
                    {props.action?.libraryName !== "SERVICE-DESK-PLUS" && <Button
                        className={btnChangeColor === 1 ? "btn-gray" : ""}
                        id="button-group"
                        onClick={(e) => handleClick(1)}
                        variant="outlined"
                    >
                        {t("PARAMSMODAL.CREDENTIALS")}
                    </Button>}
                    <Button
                        className={btnChangeColor === 3 ? "btn-gray" : ""}
                        id="button-group"
                        onClick={(e) => handleClick(3)}
                        variant="outlined"
                    >
                        {t("PARAMSMODAL.CUSTOM-STRING")}
                    </Button>
                </ButtonGroup>
                <div className="params-list">
                    {value === 3 ? customString() : props.action?.libraryName !== "SERVICE-DESK-PLUS" && credentialsPicker()}
                </div>
            </DialogContentText>
        }
    }

    return (
        <Dialog
            open={true}
            onClose={handleClose}
            data-test="about-dialog"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="variables-dialog"
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    {props.title} {!props.isActiveDirectory && t("PARAMSMODAL.ADD")}
                    <Button data-test="canceldialog-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent
                id="alert-dialog-description"
                className="dialog-content-area"
            >
                {!props.isActiveDirectory ?
                    <DialogContentText
                        color="textPrimary"
                        style={{ paddingTop: "1rem", width: "100%" }}
                    >
                        <FormControl className={props.formData ? 'width-50' : ''} >
                            <span className="params-title">{props.title}</span>
                            <BootstrapInput
                                value={paramsName || ""}
                                onChange={(e) => setParamsName(e.target.value)}
                            />
                        </FormControl>
                        {
                            props.formData && <FormControl className="m-l-20 ">
                                <span className="params-title">{t("PARAMSMODAL.TYPE")}</span>
                                <ButtonGroup size="medium" aria-label="small outlined button group">
                                    <Button
                                        className={valueType === 'text' ? "btn-gray" : ""}
                                        id="button-group"
                                        onClick={() => updateValueType('text')}
                                        variant="outlined"
                                    >
                                        {t("PARAMSMODAL.TEXT")}
                                    </Button>
                                    <Button
                                        className={valueType === 'file' ? "btn-gray" : ""}
                                        id="button-group"
                                        onClick={() => updateValueType('file')}
                                        variant="outlined"
                                    >
                                        {t("PARAMSMODAL.FILE")}
                                    </Button>
                                </ButtonGroup>
                            </FormControl>
                        }
                        <FormControlLabel
                            style={{ marginLeft: "20px", marginTop: "1.5rem" }}
                            control={
                                <Checkbox
                                    checked={active}
                                    onChange={() => setActive(!active)}
                                    name="setAsInput"
                                    color="#C4C4C4"
                                />
                            }
                            label={t("PARAMSMODAL.ACTIVE")}
                        />

                    </DialogContentText> :
                    <DialogContentText
                        color="textPrimary"
                        style={{ width: props.isActiveDirectory && "400px" }}
                    ></DialogContentText>
                }
                {showValueDesign()}
                <Button variant="outlined" data-test="submitdialog-button"
                    style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
                    onClick={handleAdd}>
                    {t("PARAMSMODAL.ADD")}
                </Button>
                <Button variant="outlined" data-test="submitdialog-button"
                    style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
                    onClick={handleClose}>
                    {t("PARAMSMODAL.CANCEL")}
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default ParamsModal;
